import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
// import AboutCompanyImg from '../assets/images/about/about-company-img.jpg' 

function AboutCompany({data}) {
  return (
    <> 
    {(data) && (
    <section className="about-company">
      <Container>
        <Row className="align-items-center">
          <Col sm="12" lg="8" xxl="9">    
            <div className="about-company-box">        
              <h2>{data.title}</h2>
              <p dangerouslySetInnerHTML={{ __html: data.description }}></p>
            </div>
          </Col>
          <Col sm="12" lg="4" xxl="5" className='about-company-img-col'>   
            <img className="about-company-img" src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${data.image}`} alt="" />
          </Col>
        </Row>        
      </Container>
    </section>
    )}
    </>
  )
}
export default AboutCompany